export default __webpack_public_path__ + "static/media/palce.55230c84.png";